import React, { useState, useRef, useEffect } from "react";
import {
  getOurCulturePhotos,
  resetCompanyProfileDetails,
} from "../../../../redux/actions";

import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "antd";
import "./Ourculturephotos.css";
import "antd/dist/antd.css";

import {
  DeleteOutlined,
  ArrowLeftOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Skeleton } from "antd";
import Loader from "../../../../components/Loading/Loader";

import { getImage } from "../../../../utilities/storageOperations/downloadURL";

import { fetchToken } from "../../../../API/API";
import axios from "axios";
import TopAlert from "../../../../components/TopNotification/TopAlert";
import history from "../../../../routes/history";
import Uploadbanner from "../../../Conversations/components/ChatCard/components/Uploadbanner/Uploadbanner";

const OurCulturePhotos = () => {
  const loading = useSelector((state) => state.getCulturePhotos.loading);
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;
  const [processLoading, setProcessLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [fileSizeCheck, setFileSizeCheck] = useState(false);
  const [fileTypeCheck, setFileTypeCheck] = useState(false);

  const [Dimensions, setDimensions] = useState(getWindowDimensions());

  const inputFile = useRef(null);

  const dispatch = useDispatch();
  const photos = useSelector((state) => state.getCulturePhotos.photos);

  const [src, setSrc] = useState("");
  const [imageSources, setImageSources] = useState([]);

  const [fileList, setFileList] = useState([]);
  const [fileList2, setFileList2] = useState([]);

  //   if (photos.length) {

  //     const list = [];

  //     for (var i = 0; i < photos[0]?.Pictures?.length; ++i) {

  //       list.push({
  //         url: await getImage(photos[0]?.Pictures[i]?.Filename),
  //         s3key: photos[0]?.Pictures[i]?.Filename,
  //       });

  //       files.push({ s3key: photos[0]?.Pictures[i]?.Filename })
  //       imageSources.push({ src: await getImage(photos[0]?.Pictures[i]?.Filename) })
  //     }
  //     console.log("list ===== ", list);
  //     setFileList2(list);
  //   }
  // }, [photos]);

  useEffect(async () => {
    if (photos.length) {
      const list = [];

      for (var i = 0; i < photos[0]?.Album_Pictures?.length; ++i) {
        // list.push({
        //   url: await getImage(photos[0]?.Album_Pictures[i]?.Filename),
        //   s3key: photos[0]?.Album_Pictures[i]?.Filename,
        // });
        // console.log(
        //   "imagewefweff:",
        //   `${process.env.REACT_APP_S3_URL}/content/pics/albums/thumbs/${photos[0]?.Album_Pictures[i]?.Filename}`
        // );

        files.push({ s3key: photos[0]?.Album_Pictures[i]?.Filename });

        imageSources.push({
          src: `${process.env.REACT_APP_S3_URL}/content/pics/albums/thumbs/${photos[0]?.Album_Pictures[i]?.Filename}`,
        });
      }
      setFileList2(list);
    }
  }, [photos]);

  useEffect(() => {
    setFiles([]);
    setImageSources([]);
    dispatch(getOurCulturePhotos("CULTR"));
  }, []);
  
  const resizeImage = (file, maxWidth = 800, maxHeight = 800) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();
  
      reader.onload = function (e) {
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
  
      img.onload = function () {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
  
        const ratio = Math.min(maxWidth / img.width, maxHeight / img.height);
        const width = img.width * ratio;
        const height = img.height * ratio;
  
        canvas.width = width;
        canvas.height = height;
  
        ctx.drawImage(img, 0, 0, width, height);
  
        canvas.toBlob(resolve, file.type, 0.7); 
      };
  
      img.onerror = function () {
        reject("Error resizing image.");
      };
    });
  };
  
  const readURL = async (input) => {
    setFileSizeCheck(false);
    setFileTypeCheck(false);
  
    const file = input.target.files[0];
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
    if (!allowedTypes.includes(file.type) || file.name.toLowerCase().endsWith(".jfif")) {
      setFileTypeCheck(true);
    } else if (file.size > 10000000) {
      setFileSizeCheck(true);
    } else {
      try {
        const resizedBlob = await resizeImage(file);
        const resizedFile = new File([resizedBlob], file.name, { type: file.type });
  
        var reader = new FileReader();
        reader.onload = (e) => {
          let image = new Image();
          image.src = e.target.result;
  
          image.onload = () => {
            setSrc(e.target.result);
            setImageSources((prev) => [...prev, { src: e.target.result }]);
            uploadImage(resizedFile);
          };
  
          image.onerror = () => {
            setFileTypeCheck(true);
          };
        };
        reader.readAsDataURL(resizedFile);
      } catch (error) {
        console.error("Image resize failed:", error);
      }
    }
  
    input.target.value = "";
  };
  
  // const readURL = async (input) => {
  //   setFileSizeCheck(false);
  //   setFileTypeCheck(false);
  
  //   const file = input.target.files[0];
  
  //   if (
  //     file.type !== "image/png" &&
  //     file.type !== "image/jpeg" &&
  //     file.type !== "image/jpg"
  //   ) {
  //     setFileTypeCheck(true);
  //   } else if (file.size > 10000000) {
  //     setFileSizeCheck(true);
  //   } else {
  //     try {
  //       const resizedBlob = await resizeImage(file);
  //       const resizedFile = new File([resizedBlob], file.name, { type: file.type });
  
  //       var reader = new FileReader();
  //       reader.onload = (e) => {
  //         let image = document.createElement("img");
  //         image.src = e.target.result;
  //         let source = e.target.result;
  
  //         image.onload = () => {
  //           setSrc(e.target.result);
  //           setImageSources((prev) => [...prev, { src: source }]);
  //           uploadImage(resizedFile); 
  //         };
  
  //         image.onerror = () => {
  //           setFileTypeCheck(true);
  //         };
  //       };
  //       reader.readAsDataURL(resizedFile);
  //     } catch (error) {
  //       console.error("Image resize failed:", error);
  //     }
  //   }
  
  //   input.target.value = "";
  // };

  const onRemove = async (file) => {
    setProcessLoading(true);
    const headers = await fetchToken();
    const removeUrl = `${BackendApiBaseUrl}/empprofile/albums/delete/CULTR`;
    const payload = {
      Filename: file.s3key,
    };
    try {
      const response = await axios.put(removeUrl, payload, { headers });
    } catch (error) {
      if (error.message == "Request failed with status code 500") {
        setDeleteSuccess(true);
        setProcessLoading(false);
      }
      setTimeout(() => {
        setDeleteSuccess(false);
        setProcessLoading(false);
      }, 3000);
    }
  };

  const removeImage = (index) => {
    imageSources.splice(index, 1);
    setImageSources([...imageSources]);
    onRemove(files[index]);

    files.splice(index, 1);
    setFiles([...files]);
  };

  const uploadImage = async (file) => {
    setProcessLoading(true);
    const headers = await fetchToken();
    const payload = {
      type: "albums",
      contentType: file.type,
      albums: true,
    };

    // console.log("token is", headers);
    const imageUrl = `${BackendApiBaseUrl}/upload`;
    // const imageUrl = `http://192.168.18.36:4000/production/upload`
    const data = await axios.post(imageUrl, payload, { headers });
    const response = data.data;
    // console.log("Response =", response);
    const fileWithKey = { ...file, s3key: response.Key };
    setFiles([...files, fileWithKey]);

    const uploadRequestS3 = await axios.put(response.uploadURL, file);

    const body = {
      Pictures: [
        {
          Filename: response.Key.split("/")[4],
          FileSize: file.size,
        },
      ],
    };
    // console.log("Upload Cultr Pics API headers>>", headers);
    const uploadRequest = await axios.put(
      `${BackendApiBaseUrl}/empprofile/albums/update/CULTR`,
      // `http://192.168.18.138:4000/development/empprofile/albums/update/CULTR`,
      body,
      { headers }
    );
    if (uploadRequest.status == 200) {
      // console.log("cultural photos<< upload>>", uploadRequest.status);
      setUploadSuccess(true);
      setProcessLoading(false);
    }
    setTimeout(() => {
      setUploadSuccess(false);
      setProcessLoading(false);
    }, 3000);
  };

  // window.scrollTo(0, 0);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    // console.log("imageSources>>", imageSources);
    function handleResize() {
      setDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <div
        className={
          Dimensions.width > 768 ? "mainContainer" : "mainContainer-mobile"
        }
      >
        {fileTypeCheck ? (
          <TopAlert
            display={"flex"}
            title={"File format not supported"}
            type="warning"
          />
        ) : null}
        {fileSizeCheck ? (
          <TopAlert
            display={"flex"}
            title={"File size should not exceed 10MB"}
            type="warning"
          />
        ) : null}
        {uploadSuccess ? (
          <TopAlert
            display={"flex"}
            title={"Photo successfully uploaded"}
            type="success"
          />
        ) : null}

        {deleteSuccess ? (
          <TopAlert
            display={"flex"}
            title={"Photo successfully deleted"}
            type="success"
          />
        ) : null}
        <>
          {/* {Dimensions.width > 768 ? (
            <div className="title">Add pictures of the company’s culture</div>
          ) : null} */}
          <div className="subContainer">
            <Row
              gutter={[16, 16]}
              // style={{ width: imageSources.length < 1 && "55%" }}
              className="rowCulture"
              // style={{marginBottom: '159px'}}
            >
              {Dimensions.width < 564 && (
                <a
                  style={{
                    fontSize: "22px",
                    paddingLeft: "2.5px",
                    color: "black",
                  }}
                  onClick={() => history.goBack()}
                >
                  &larr;
                </a>
              )}

              {/* {Dimensions.width < 768 ? (
                <div className="title-mobile">Add pictures of the company’s culture</div>
              ) : null} */}
              <div className="title-mobile">Add pictures of the company’s culture</div>

              <div className="text-description">
                {" "}
                Highlight your company’s culture! Add pictures like your offices
                or past events.
                <br />
                <br /> Upload as many pictures as you want to showcase the
                company’s culture. Drag and drop your pictures to arrange them.
                <br />
              </div>
              
              {loading ? (
  <div
    className="ShimmerDiv"
    style={{
      margin: "auto",
      marginTop: "10%",
      marginBottom: "25%",
    }}
  >
    <Skeleton.Image active />
  </div>
) : (
  <div className="row-custom">
      {imageSources.map((image, index) => {
        return (
          <Col
            key={index}
            span={6}
            xs={24}
            sm={12}
            md={8}
            xl={6}
            // style={{
            //   padding: Dimensions.width > 564 ? "0px" : "8px",
            // }}
             className="no-padding-col"
          >
            <div
              className="deleteIcon"
              onClick={() => removeImage(index)}
            >
              <div className="del">
                <DeleteOutlined />
              </div>
            </div>
            <img
              style={{
               
                objectFit: "cover",
              }}
              id="blah"
              src={image.src}
              className="image"
              alt="Company culture photo"
            />
          </Col>
        );
      })}
  </div>
)}

              <div className="buttonContainerCulture">
                <button style={{border:'none'}}
                  // className="btnn"
                  onClick={() =>
                    !processLoading ? inputFile.current.click() : null
                  }
                >
                   <Uploadbanner width="240" height="240" aspectRatio="1:1"/>
                </button>
                {/* <Uploadbanner/> */}

                <input
                  type="file"
                  accept="image/png, image/jpeg, image/jpg"
                  ref={inputFile}
                  id="desktopInput"
                  onChange={readURL}
                />
              </div>
            </Row>
          </div>
        </>
      </div>
    </div>
  );
};

export default OurCulturePhotos;
